import { useTranslation } from "react-i18next";
import etapas from "../../../assets/etapas.png";

export default function Etapas() {
  const { t } = useTranslation();
  return (
    <section id="etapas-section">
      <h1>{t("producao.etapas.titulo")}</h1>
      <p>{t("producao.etapas.descricao")}</p>
      <img src={etapas} alt="Imagem das Etapas de Produção" />
    </section>
  );
}
